import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import LanguageSelector from './LanguageSelector';
import './Header.scss';
import { LanguageCode } from '../constants/app';

const Header: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { login } = useAuth();

  const handleLanguageChange = (langCode: LanguageCode) => {
    i18n.changeLanguage(langCode);
  };

  // Type guard to ensure language is a valid LanguageCode
  const getCurrentLanguage = (): LanguageCode => {
    const currentLang = i18n.language;
    return (currentLang === 'lt' || currentLang === 'en') ? currentLang : 'lt';
  };

  const handleLoginClick = () => {
    login();
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <h1 className="logo">Mano PVM</h1>
          <nav className="nav">
            <LanguageSelector 
              currentLanguage={getCurrentLanguage()}
              onLanguageChange={handleLanguageChange}
            />
            <button className="login-btn" onClick={handleLoginClick}>
              {t('loginButton')}
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
